import { setRequireGlassGuide } from '@/context/display';
import { store } from '@/context/store';

export function setInitialRequireGlassGuide(requireGlassGuide: boolean): void {
    const stateRequire = store.getState().displayReducer.requireGlassGuide;
    if (stateRequire !== requireGlassGuide) {
        store.dispatch(setRequireGlassGuide(requireGlassGuide));
    }
}
